import { searchParamsData } from '@/lib/sbAPI'
import { getStoryblokApi } from '@/lib/storyblok-api'
let location = process.env.NEXT_PUBLIC_NEXT_LOCATION ?? 'au'
let filterLocation = location === 'en-nz' ? 'au' : `en-nz`
export const fetchAdvisers = async (officeId: string) => {
  try {
    let sbParams = {
      ...searchParamsData,
      filter_query: {
        component: { in: 'adviser' },
        // Hide profiles that should not appear in adviser search results.
        hideFromSearch: { not_in: 'true' },
        offices: { any_in_array: officeId },
        __or: [
          { 'settings.location_available': { in: location } },
          { 'settings.location_available': { not_in: filterLocation } },
        ],
      },
      sort_by: 'content.givenName:asc',
      // NOTE: chances of there being more than 100 advisers is low so we can set a high number
      per_page: 100,
    }

    const storyblokApi = getStoryblokApi()
    let { data } = await storyblokApi.get(`cdn/stories/`, sbParams)
    return Array.isArray(data?.stories)
      ? data.stories.filter((story: any) => story?.content?.hideFromSearch !== true)
      : []
  } catch (error) {
    console.error('Error fetching advisers:', error)
    return []
  }
}
